import React from 'react'
import type { ImageTextProps, ImageTextType } from './ImageText.types'
import { Region, transformRegionToMap } from 'msp-integrations'
import { twMerge } from 'tailwind-merge'
import Image from '@atoms/Image/Image'

const ImageText = ({
  className,
  imageUrl,
  imageAlt,
  imagePosition = 'left',
  background = 'light',
  contentPosition = 'center',
  ...props
}: ImageTextProps) => {
  const bgColors = {
    dark: 'bg-imageTextDarkBackground',
    light: 'bg-imageTextLightBackground',
    black: 'bg-black'
  }
  const imageDiv = (
    <div className='relative h-1 overflow-hidden pt-[100%] md:sticky md:top-0'>
      <Image
        className='absolute top-0 left-0 object-cover w-full h-full'
        src={imageUrl}
        alt={imageAlt}
        ratio='1/2'
      />
    </div>
  )

  return (
    <div
      className={twMerge(
        'grid grid-cols-1 md:grid-cols-2',
        bgColors[background],
        className
      )}
    >
      {imagePosition === 'left' && imageDiv}
      <div
        className={twMerge(
          'grid h-full px-8 py-14 md:sticky md:px-12 xl:px-28',
          contentPosition === 'center' ? 'content-center' : 'content-start'
        )}
      >
        {props.children}
      </div>
      {imagePosition === 'right' && imageDiv}
    </div>
  )
}

export const ImageTextComponent = ({
  data,
  regions,
  custom
}: ImageTextType) => {
  const content = transformRegionToMap(regions).get('content')

  return (
    <ImageText
      imagePosition={data.imagePosition}
      background={data.bgStyle}
      imageUrl={custom?.content?.image?.path}
      imageAlt={data.imageAlt}
    >
      {content && <Region region={content} />}
    </ImageText>
  )
}

export default ImageText
